import template from './QueueItemView.html';
import { QueueItemController } from '../QueueItem/QueueItemController';
export const QueueItemComponent = {
    require: {
        ngModel: '?ngModel',
    },
    controller: QueueItemController,
    controllerAs: '$ctrl',
    template,
    bindings: {
        data: '<',
        application: '<',
        canEditQueue: '<',
        canSeeQueue: '<',
        properties: '<',
        onEdit: '&?',
        onDelete: '&?',
        onCancel: '&?',
        elementId: '@?',
        onSave: '&?',
        isManagerView: '<',
        currentState: '<',
    },
};
